/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Teams_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Group people the way they actually collaborate, for example by department or by project. Then grant each team the spaces and projects it needs, so access fol..." |
*
* @param {Uno_Edu_Intro_Teams_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_teams_chip1_answer = /** @type {((inputs?: Uno_Edu_Intro_Teams_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Teams_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppieren Sie Personen so, wie sie tatsächlich zusammenarbeiten, etwa nach Abteilung oder Projekt. Gewähren Sie dann jedem Team die benötigten Spaces und Projekte, sodass der Zugriff der Gruppe automatisch folgt.")
	return /** @type {LocalizedString} */ ("Group people the way they actually collaborate, for example by department or by project. Then grant each team the spaces and projects it needs, so access follows the group automatically.")
});